import { useEffect, useMemo, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
// import { DevTool } from "@hookform/devtools";
import useAxios from "../hooks/useAxios";
import axiosInstance from "../apis/commonAPI";
// import {SESSION_DATA, user,} from "../../constants";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaArrowDown, FaArrowRight } from "react-icons/fa";
import Checkbox from "react-custom-checkbox";
import paramarshLogo from "../assets/paramarshLogo.png";
import { WiSleet, WiSunrise, WiSunset } from "react-icons/wi";
import { PiClockAfternoonThin } from "react-icons/pi";
import { MdOutlineNightlight } from "react-icons/md";
import { BsCalendarDateFill } from "react-icons/bs";
import { IoIosArrowBack } from "react-icons/io";
import Moment from "moment";
import { extendMoment } from "moment-range";

const UnblockExpSlotsPublic = () => {
     const navigate = useNavigate();
      const moment = extendMoment(Moment);
    const curDate = moment().format("YYYY-MM-DD");
    const tomorrow = moment().add(1, 'day').format("YYYY-MM-DD");
    const [addUpdate, setAddUpdate] = useState(false);
    const [slotUpdate, setSlotUpdate] = useState(false);
    const [expLocations, setExpLocations] = useState([]);

     const [userExpData, errorUserExp, loadingUserExp, axiosUserExp] =
          useAxios();
     const [slotData, errorSlot, loadingSlot, axiosSubmitSlot] =
     useAxios();
     const [slotUpdateData, errorSlotUpdate, loadingSlotUpdate, axiosSubmitSlotUpdate] =
     useAxios();
     const [locationsData, errorLocations, loadingLocations, axiosSubmitLocations] =
     useAxios();


    const getLocations = (url) => {
      axiosSubmitLocations({
                axiosInstance: axiosInstance,
                url: url,
                method: "GET",
              });
            };
            console.log("get loca",locationsData)
    const getUserExpData = (url) => {
            axiosUserExp({
                axiosInstance: axiosInstance,
                url: url,
                method: "GET",
              });
            };

    useEffect(() => {
        getUserExpData("expert/unblockexpslotpublic");

    },[])
console.log("userExpData",userExpData)
    const form = useForm({
        defaultValues: {
         
          slotStartDate: curDate,
          slotEndDate: tomorrow,
        },
      });
      const {
        register,
        control,
        handleSubmit,
        formState,
        watch,
        setValue,
        getValues,
        resetField,
        reset,
      } = form;
      const { errors } = formState;

       const onFormSubmit = async (data) => {
          let formData = {
            userId: data?.expertName,
            fromDate: data?.slotStartDate,
            toDate: data?.slotEndDate,
            locationId:data?.location?data?.location:"",
            userType: "expert"
           
          };
      console.log("formDatasss",formData)
      
          await axiosSubmitSlot({
            axiosInstance: axiosInstance,
            url: `booking/getExpertBookedSlotsPublic`,
            method: "POST",
            requestConfig: {
              data: formData,
            },
          });
      
          setAddUpdate(true);
        };
        console.log("slotData",slotData)
        useEffect(() => {
            if(addUpdate && slotData?.[0]?.success  ){
                if(slotData?.[0]?.excelData?.length>0){
                    toast.success(slotData?.[0]?.message, {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 500,
                      })
                }else{
                    toast.success("No Booked Slot Found", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 500,
                      })
                }
               

            }else if(!slotData?.[0]?.success)  {
                toast.error(slotData?.[0]?.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 500,
                  })
            }
            setAddUpdate(false);


        },[loadingSlot])

        const handleSlot = async (slotBookId="",slotMainId="",shiftName="",slotId="") => {
          if(slotBookId&&slotMainId&&shiftName&&slotId){
            let slotUpdateData = {
              slotBookId:slotBookId,
              slotMainId:slotMainId,  
              shiftName:shiftName,
              slotId:slotId,

            }
            await axiosSubmitSlotUpdate({
              axiosInstance: axiosInstance,
              url: `booking/slotReassignDataPublic`,
              method: "POST",
              requestConfig: {
                data: slotUpdateData,
              },
            });
        
            setSlotUpdate(true);
            
            
             
                
                
                
                  
                }

               

        }
        useEffect(() => {
            if(slotUpdate && slotUpdateData?.[0]?.success  ){
                toast.success(slotUpdateData?.[0]?.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 500,
                  })
                  handleSubmit(onFormSubmit)();
               

            }else if(slotUpdate && !slotUpdateData?.[0]?.success)  {
                toast.error(slotUpdateData?.[0]?.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 500,
                  })
            }
            setSlotUpdate(false);
        },[loadingSlotUpdate])

        const handleLocations = (e) =>{
          if(e.target.value){
            getLocations(`booking/getLocationsByExpertPublic/${e.target.value}`)

          }
        }
        useEffect(() =>{
          if(locationsData?.[0]?.success){
          setExpLocations(locationsData?.[0]?.data)


          }else{
            setExpLocations([])

          }

        },[locationsData])



 return (
     <>
       
 
 
 <div className="card min-height-100">
         <div className="card-title flex-row">
           <h2 className="text-navyBlue"> UnBlock Booked Slots </h2>
          
         </div>
 
 
         <ToastContainer />
         
         <FormProvider {...form}>
           <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
             <div className="row mt-30">
               
               
               <div className="col-md-3  tank-col-info">
                     <label
                       htmlFor="expertName"
                       className="text-gray text-semi-bold"
                     >
                       Expert Name<span className="text-red">*</span>
                     </label>
 
                     <select
                       id="expertName"
                       {...register("expertName", {
                         required: {
                           value: true,
                           message: "Expert Name Field is Required",
                         },
                       })}
                       type="text"
                       className="form-control rounded-10 mb-15"
                       placeholder="Select Expert"
                       onClick={(e) => handleLocations(e)}
                       
                    
                       
                     >
                       <option value="">Select Expert</option>
                       {userExpData?.[0]?.data?.map((listFetch, index) => (
                        (
                        <option
                        key={listFetch?._id}

                          value={`${listFetch?._id}`}
                        >
                          { listFetch?.expertName}
                        </option>
                      )
                      ))}
                     </select>
 
                     <p className="text-red">{errors.expertName?.message}</p>
                   </div>
               <div className="col-md-3  tank-col-info">
                     <label
                       htmlFor="location"
                       className="text-gray text-semi-bold"
                     >
                        Location
                     </label>
 
                     <select
                       id="location"
                       {...register("location", {
                         required: {
                           value: false,
                           message: "Location Name Field is Required",
                         },
                       })}
                       type="text"
                       className="form-control rounded-10 mb-15"
                       placeholder="Select Location"
                      
                       
                    
                       
                     >
                       <option value="">Select Location</option>
                       {expLocations?.map((listFetch, index) => (
                        (
                        <option
                        key={listFetch?.locationId}

                          value={`${listFetch?.locationId}`}
                        >
                          { listFetch?.locationName}
                        </option>
                      )
                      ))}
                     </select>
 
                     <p className="text-red">{errors.expertName?.message}</p>
                   </div>
               
             
               <div className="col-md-3  tank-col-info">
                 <label
                   htmlFor="slotStartDate"
                   className="text-gray text-semi-bold"
                 >
                   Slot Start Date<span className="text-red">*</span>
                 </label>
                
                  <input
                       id="slotStartDate"
                       {...register("slotStartDate", {
                         required: { value: true, message: "Enter Slot Start Date" },
                         validate: (value) => {
                           const slotEndDate = new Date(getValues("slotEndDate"));
                           const slotStartDate = new Date(value);
                           const today = new Date();
       today.setHours(0, 0, 0, 0);
    //    if (slotStartDate < today) {
    //      return "Slot Start Date cannot be in the past";
    //    }
     
       if (getValues("slotEndDate") && slotStartDate >= slotEndDate) {
         return "Slot Start Date must be earlier than Slot End Date";
       }
     
       return true;
     
                     
                          
                         },
                       })}
                       type="date"
                       className="form-control rounded-10 mb-15"
                       placeholder="Slot End Date"
                       title="select End date"
                     />
                 <p className="text-red">{errors.slotStartDate?.message}</p>
               </div>
               <div className="col-md-3  tank-col-info">
                 <label
                   htmlFor="slotEndDate"
                   className="text-gray text-semi-bold"
                 >
                   Slot End Date<span className="text-red">*</span>
                 </label>
                 
 
 <input
                       id="slotEndDate"
                       {...register("slotEndDate", {
                         required: { value: true, message: "Enter End Date" },
                         validate: (value) => {
                           const slotStartDate = new Date(getValues("slotStartDate"));
                           const slotEndDate = new Date(value);
                     
                           return (
                             !getValues("slotStartDate") ||
                             slotEndDate > slotStartDate ||
                             "End Date must be after Start Date"
                           );
                         },
                       })}
                       type="date"
                       className="form-control rounded-10"
                       placeholder="End Date"
                       title="select End date"
                     />
                 <p className="text-red">{errors.slotEndDate?.message}</p>
               </div>
               
 
               <div className="col-md-3 text-left mt-20">
                 <input
                   type="submit"
                   className="btn btn-sm btn-secondary rounded-20"
                   value="Submit"
                 />
               </div>
             </div>
           </form>
         </FormProvider>
         <hr className="mt-20 mb-20" />
    {/* <div className="row " >
      {[
        "Morning Shift",
        "Afternoon Shift",
        "Evening Shift",
        "Night Shift",
      ]?.map((fetchShiftRow, index) =>
        shiftData?.[0]?.ShiftData?.map((fetchRow, index) =>
          fetchShiftRow == fetchRow?.shiftName ? (
            <>
              <div
                className="col-md-3  tank-col-info text-center"
                onClick={(e) => handleClick(fetchRow?.shiftName)}
              >
                <label
                  htmlFor=""
                  className={
                    shiftFlag === fetchRow?.shiftName
                      ? " btn-no-outline-green cursor"
                      : "text-black  btn-no-outline-gray cursor"
                  }
                >
                  {fetchRow?.shiftName == "Morning Shift" ? (
                    <WiSunrise />
                  ) : fetchRow?.shiftName == "Evening Shift" ? (
                    <WiSunset />
                  ) : fetchRow?.shiftName == "Afternoon Shift" ? (
                    <PiClockAfternoonThin />
                  ) : fetchRow?.shiftName == "Night Shift" ? (
                    <MdOutlineNightlight />
                  ) : (
                    ""
                  )}
                  {fetchRow?.shiftName} <br />
                 
                </label>
              </div>
            </>
          ) : (
            <></>
          )
        )
      )}
    </div> */}
   
    {
    slotData?.[0]?.success && slotData?.[0]?.excelData ?.map((fetchRows, gindex) => (
      <>
      {
        fetchRows?.bookingStatus == 'B'?<>
         <div className="row">
          <div className="col-md-2  tank-col-info text-center">
            <div className="btn btn-no-outline-gray rounded-5 btn-wrapper">
              
              <label >
                {" "}
                {moment(fetchRows?.slotDate).format("DD MMMM YYYY")}

              </label>
            </div>
          </div>
          <div className="col-md-10  tank-col-info text-left">
            <span className="text-black text-bold ml-5">
               
                  


                  <button
                    className="btn-slot  btn-outline-red  rounded-10 mr-5 ml-5  p-5"
                      title="Slot Booked by User!! Click To Free Slot"
                      
                         onClick={() =>
                      handleSlot(
                        fetchRows?._id,
                        fetchRows?.slotMainId,
                        fetchRows?.shiftName,
                        fetchRows?.slotId,

    )}
                  >
                    
                      {fetchRows?.slotTime}
                  </button>
                  
               
              
            </span>
          </div>
        </div>
        <hr className="mt-20 mb-20" />

        </>:<></>
      }
       
      </>
    ))
    }
 
 
        
       </div>
     </>
   );
}

export default UnblockExpSlotsPublic